import { faAdd, faMinus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Box, HStack, Pressable } from 'native-base';
import React from 'react';
import { SpIcon } from '~/shared/Icon';
import { Input } from '~/shared/Theme';
import { useTheme } from '@springbig/shared';

type QuantityPickerProp = {
    quantity: number;
    maxQuantity: number;
    setQuantity: (value: number) => void;
    isLoading: boolean;
    isNullable?: boolean;
    variant: 'small' | 'large';
};

export const QuantityPicker = ({
    quantity,
    maxQuantity,
    setQuantity,
    isLoading,
    isNullable = true,
    variant,
}: QuantityPickerProp) => {

    const {
        button_primary,
        button_text,
        radius_sm,
        field_border_size,
    } = useTheme();

    const lowestBound = isNullable ? 0 : 1;
    const isRemoveDisabled = isLoading || quantity <= lowestBound;
    const isAddDisabled = isLoading || quantity >= maxQuantity;

    const onChangeValue = (value) => {

        const intValue = parseInt(value.slice(0, 3));
        if (intValue) {
            setQuantity(intValue);
        }
    };

    const onBlur = () => {

        if (isNaN(quantity) || typeof quantity !== 'number' || quantity < lowestBound) {
            setQuantity(lowestBound);
        }

        if (quantity > maxQuantity) {
            setQuantity(maxQuantity);
        }
    };

    return ( variant === 'small' ?
        <HStack alignItems={'center'} alignSelf={'center'}>
            <Pressable
                disabled={isRemoveDisabled}
                onPress={() => setQuantity(quantity - 1)}
            >
                <Box
                    w={'40px'}
                    h={'30px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    background={button_text}
                    borderColor={button_primary}
                    borderLeftRadius={radius_sm}
                    borderWidth={1}
                    opacity={isRemoveDisabled ? .5 : 1}
                >
                    <SpIcon
                        icon={quantity === 1 && isNullable ? faTrash : faMinus}
                        color={button_primary}
                        size={14}
                    />
                </Box>
            </Pressable>
            <Input
                w={'40px'}
                h={'30px'}
                p={0}
                rounded={0}
                borderTopWidth={1}
                borderBottomWidth={1}
                borderLeftWidth={0}
                borderRightWidth={0}
                textAlign={'center'}
                isDisabled={isLoading}
                value={quantity.toString()}
                onChangeText={onChangeValue}
                onBlur={onBlur}
            />
            <Pressable
                disabled={isAddDisabled}
                onPress={() => setQuantity(quantity + 1)}
            >
                <Box
                    w={'40px'}
                    h={'30px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    background={button_text}
                    borderColor={button_primary}
                    borderRightRadius={radius_sm}
                    borderWidth={1}
                    opacity={isAddDisabled ? .5 : 1}
                >
                    <SpIcon icon={faAdd} color={button_primary} size={14} />
                </Box>
            </Pressable>
        </HStack>
        :
        <HStack alignItems={'center'} space={4} alignSelf={'center'}>
            <Pressable
                disabled={isRemoveDisabled}
                onPress={() => setQuantity(quantity - 1)}
            >
                <Box
                    w={'40px'}
                    h={'40px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    borderWidth={1}
                    borderColor={button_primary}
                    bg={button_text}
                    borderRadius={radius_sm}
                    opacity={isRemoveDisabled ? .5 : 1}
                >
                    <SpIcon
                        icon={quantity === 1 && isNullable ? faTrash : faMinus}
                        color={button_primary}
                        size={14}
                    />
                </Box>
            </Pressable>
            <Input
                minW={'48px'}
                textAlign={'center'}
                isDisabled={isLoading}
                value={quantity.toString()}
                onChangeText={onChangeValue}
                onBlur={onBlur}
            />
            <Pressable
                disabled={isAddDisabled}
                onPress={() => setQuantity(quantity + 1)}
            >
                <Box
                    w={'40px'}
                    h={'40px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    borderWidth={1}
                    borderColor={button_primary}
                    bg={button_text}
                    borderRadius={radius_sm}
                    opacity={isAddDisabled ? .5 : 1}
                >
                    <SpIcon icon={faAdd} color={button_primary} size={14} />
                </Box>
            </Pressable>
        </HStack>
    );
};
